import React from 'react';
import './Styles/Product.scss';
import Card from '../../Shared/Cards/HubCard/Card';
import { productCards } from './data';
const Product=()=>{
    return(
        <div className="product-hub">
            <h1>Product Updates</h1>
            <p>Keep up with all our product launches, small ships and news</p>
            <div className="cards">
            {productCards.map((d) =>{
                    return(
                        <Card {...d}/>
                    )
                })}
            </div>
        </div>
    )
};
export default Product ;